import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallCenterDialerRoutingModule } from './call-center-dialer-routing.module';
import { CallCenterDailerComponent } from '../call-center-dailer.component';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import {FileUploadModule} from 'primeng/fileupload';
import { ToastModule} from 'primeng/toast';
import {TableModule } from 'primeng/table';
import {ToggleButtonModule } from 'primeng/togglebutton';
import {DropdownModule } from 'primeng/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import {PaginatorModule} from 'primeng/paginator';
import {DialogModule} from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import {CalendarModule} from 'primeng/calendar';
import {MultiSelectModule} from 'primeng/multiselect';
import {TabMenuModule} from 'primeng/tabmenu';
import {StepsModule} from 'primeng/steps';
import {PanelModule} from 'primeng/panel';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@NgModule({
  declarations: [CallCenterDailerComponent],
  imports: [
    CommonModule,
    CallCenterDialerRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    ModalModule.forRoot(),
    FileUploadModule,
    ToggleButtonModule,
    TableModule,
    ToastModule,
    PaginatorModule,
    DialogModule,
    MultiSelectModule,
    CalendarModule,
    TabMenuModule,
    StepsModule,
    PanelModule,
    ButtonModule,
    AutoCompleteModule,
    TypeaheadModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  exports:[
    CallCenterDailerComponent
  ]
})
export class CallCenterDialerModule { }
